function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
import createContextExtractor from './createContextExtractor';
import createFormActions from './actions';
import escapeRegExp from './utils/escapeRegExp';
import React, { Component } from 'react';
import RPT from 'prop-types';
import tidyHandlers from './tidyHandlers';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
/**
* Create a field which can be used as a react component
* @param {string} fieldName - name of the field
* @param {Object|function} defaultProps - default props of the field
* @param {Array} customValidations - validations field should have, e.g. isRequired()
* @return {function} function which accepts field component to be decorated
*/

export default function connectField(fieldName) {
  var defaultProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var customValidations = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  return function (FieldComponent) {
    var Field = /*#__PURE__*/
    function (_Component) {
      _inherits(Field, _Component);
      function Field() {
        var _getPrototypeOf2;
        var _this;
        _classCallCheck(this, Field);
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Field)).call.apply(_getPrototypeOf2, [this].concat(args)));
        _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onBlur", function () {
          var _this$props = _this.props,
            onBlur = _this$props.onBlur,
            setFieldLiveValidation = _this$props.actions.setFieldLiveValidation,
            onionValidateField = _this$props.onionValidateField;
          var result = setFieldLiveValidation(fieldName, true); // call passed callback

          if (typeof onBlur === 'function') {
            onBlur({
              name: fieldName
            });
          }
          if (typeof onionValidateField === 'function') {
            onionValidateField(fieldName);
          }
          return result;
        });
        _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onFocus", function () {
          var onFocus = _this.props.onFocus;
          return onFocus && onFocus({
            name: fieldName
          });
        });
        _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onChange", /*#__PURE__*/
        function () {
          var _ref = _asyncToGenerator( /*#__PURE__*/
          regeneratorRuntime.mark(function _callee(payload, event) {
            var _this$props2, _this$props2$actions, setFieldApiError, setFieldValue, clearApiErrorOnChange, includePrefix, onChange, onionValidateField, prefix, _ref2, target, supportedInputTypes, selectionStart, selectionEnd, field, fieldValue, newValue, regexp, result;
            return regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _this$props2 = _this.props, _this$props2$actions = _this$props2.actions, setFieldApiError = _this$props2$actions.setFieldApiError, setFieldValue = _this$props2$actions.setFieldValue, clearApiErrorOnChange = _this$props2.clearApiErrorOnChange, includePrefix = _this$props2.includePrefix, onChange = _this$props2.onChange, onionValidateField = _this$props2.onionValidateField, prefix = _this$props2.prefix;
                    _ref2 = event || {}, target = _ref2.target;
                    supportedInputTypes = /text|password|search|tel|url/;
                    if (target && supportedInputTypes.test(target.type)) {
                      selectionStart = target.selectionStart;
                      selectionEnd = target.selectionEnd;
                    }
                    field = _this.getFieldProps();
                    if (field.apiError && clearApiErrorOnChange) {
                      setFieldApiError(fieldName, null);
                    }
                    fieldValue = _this.getFieldValue(payload);
                    if (!(typeof fieldValue !== 'boolean')) {
                      _context.next = 18;
                      break;
                    }
                    if (!prefix) {
                      _context.next = 15;
                      break;
                    }
                    regexp = new RegExp("^".concat(escapeRegExp(prefix))); // block modifying of prefix

                    if (!(fieldValue && !regexp.test(fieldValue))) {
                      _context.next = 12;
                      break;
                    }
                    return _context.abrupt("return", fieldValue);
                  case 12:
                    if (fieldValue.length < prefix.length) {
                      if (!includePrefix) {
                        newValue = '';
                      } else {
                        newValue = prefix;
                      }
                    } else if (!includePrefix) {
                      newValue = fieldValue.replace(prefix, '');
                    } else {
                      newValue = fieldValue;
                    }
                    _context.next = 16;
                    break;
                  case 15:
                    newValue = fieldValue;
                  case 16:
                    _context.next = 19;
                    break;
                  case 18:
                    newValue = fieldValue;
                  case 19:
                    _context.next = 21;
                    return setFieldValue(fieldName, newValue);
                  case 21:
                    result = _context.sent;

                    // call passed callback
                    if (typeof onChange === 'function') {
                      onChange({
                        name: fieldName,
                        value: newValue
                      });
                    }
                    if (typeof onionValidateField === 'function') {
                      onionValidateField(fieldName);
                    } // Restore caret position if value was normalized

                    if (payload.value !== newValue && target) {
                      /* eslint-disable no-param-reassign */
                      target.selectionStart = selectionStart;
                      target.selectionEnd = selectionEnd;
                    }
                    return _context.abrupt("return", result);
                  case 26:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, this);
          }));
          return function (_x, _x2) {
            return _ref.apply(this, arguments);
          };
        }());
        return _this;
      }
      _createClass(Field, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          var _this$props3 = this.props,
            onionFieldRegister = _this$props3.onionFieldRegister,
            defaultValue = _this$props3.defaultValue;
          var _this$_resolveDefault = this._resolveDefaultProps(),
            _this$_resolveDefault2 = _this$_resolveDefault.value,
            value = _this$_resolveDefault2 === void 0 ? defaultValue : _this$_resolveDefault2;
          onionFieldRegister(fieldName, this, value);
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          var onionFieldRegister = this.props.onionFieldRegister;
          onionFieldRegister(fieldName, null);
        }
      }, {
        key: "getFieldValue",
        value: function getFieldValue(_ref3) {
          var target = _ref3.target,
            value = _ref3.value;

          // fix checkbox to return value based on checked/unchecked
          if (typeof value === 'boolean') {
            return value;
          }
          if (!value && target) {
            return target.type === 'checkbox' ? target.checked : this.applyTidyHandlers(target.value);
          }
          return this.applyTidyHandlers(value);
        }
      }, {
        key: "getFieldProps",
        value: function getFieldProps() {
          var field = this.props.field;
          return field ? field.toJS() : {};
        }
      }, {
        key: "applyTidyHandlers",
        value: function applyTidyHandlers(value) {
          var _this$_resolveDefault3 = this._resolveDefaultProps(),
            tidy = _this$_resolveDefault3.tidy;
          if (value && tidy && tidy.length) {
            return tidy.reduce(function (result, handler) {
              if (typeof handler === 'function') {
                return handler(result);
              }
              if (tidyHandlers[handler]) {
                return tidyHandlers[handler](result);
              }
              return result;
            }, value);
          }
          return value;
        }
      }, {
        key: "validations",
        value: function validations() {
          return customValidations;
        }
      }, {
        key: "msg",
        value: function msg(key) {
          var values = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          var _this$props4 = this.props,
            onionFormName = _this$props4.onionFormName,
            msg = _this$props4.msg;
          return msg(["form.".concat(onionFormName, ".").concat(key), "form.".concat(key), "".concat(key)], values);
        }
      }, {
        key: "_resolveDefaultProps",
        value: function _resolveDefaultProps() {
          if (typeof defaultProps === 'function') {
            return defaultProps(this.props) || {};
          }
          return defaultProps;
        }
      }, {
        key: "_getErrorMessage",
        value: function _getErrorMessage() {
          var field = this.getFieldProps();
          var error = field.error || field.apiError || this.props.error;
          if (!error) {
            return null;
          }
          var errorMessage = this.msg("".concat(fieldName, ".error"));
          if (!errorMessage) {
            errorMessage = _typeof(error) === 'object' ? this.msg("errors.".concat(error.key), error.values) : this.msg("errors.".concat(error));
          }
          return errorMessage || error;
        }
      }, {
        key: "render",
        value: function render() {
          var _this$props5 = this.props,
            onionFormName = _this$props5.onionFormName,
            label = _this$props5.label,
            tooltip = _this$props5.tooltip,
            hint = _this$props5.hint,
            onClick = _this$props5.onClick,
            error = _this$props5.error,
            prefix = _this$props5.prefix,
            includePrefix = _this$props5.includePrefix;
          var field = this.getFieldProps();
          var success = field.liveValidation && !error && !!field.value;
          var defaultProps = this._resolveDefaultProps();
          var valueObject = {};
          if (prefix) {
            valueObject.value = String(field.value || '');
            if (includePrefix) {
              if (valueObject.value.length <= prefix.length) {
                valueObject.value = prefix;
              } else {
                valueObject.value = "".concat(prefix).concat(valueObject.value.replace(prefix, ''));
              }
            } else {
              valueObject.value = "".concat(prefix).concat(valueObject.value);
            }
          }
          return React.createElement(FieldComponent, _extends({}, defaultProps, this.getFieldProps(), this.props, valueObject, {
            success: success,
            error: this._getErrorMessage(),
            hint: hint || defaultProps.hint || this.msg("".concat(fieldName, ".hint")),
            label: label || defaultProps.label || this.msg("".concat(fieldName, ".label")),
            name: fieldName,
            onBlur: this.onBlur,
            onChange: this.onChange,
            onFocus: this.onFocus,
            onClick: onClick,
            onionFormName: onionFormName,
            tooltip: tooltip || defaultProps.tooltip || this.msg("".concat(fieldName, ".tooltip"))
          }));
        }
      }]);
      return Field;
    }(Component);
    _defineProperty(Field, "propTypes", {
      actions: RPT.object,
      clearApiErrorOnChange: RPT.bool,
      cnt: RPT.func,
      // custom -> given by translate() decorator #finance-translate
      defaultValue: RPT.oneOfType([RPT.string, RPT.number, RPT.bool]),
      dispatch: RPT.func,
      error: RPT.oneOfType([RPT.string, RPT.object]),
      field: RPT.object,
      hint: RPT.oneOfType([RPT.node, RPT.string]),
      // custom
      includePrefix: RPT.bool,
      label: RPT.oneOfType([RPT.node, RPT.string]),
      // custom
      msg: RPT.func,
      // custom -> given by translate() decorator #finance-translate
      onBlur: RPT.func,
      // custom
      onChange: RPT.func,
      // custom
      onClick: RPT.func,
      onFocus: RPT.func,
      // custom
      onionFieldRegister: RPT.func.isRequired,
      onionFormName: RPT.string.isRequired,
      onionLiveValidate: RPT.func.isRequired,
      onionValidateField: RPT.func.isRequired,
      prefix: RPT.string,
      tidy: RPT.arrayOf(RPT.oneOfType([RPT.oneOf(Object.keys(tidyHandlers)), RPT.func])),
      tooltip: RPT.oneOfType([RPT.node, RPT.string]),
      // custom
      validations: RPT.array
    });
    _defineProperty(Field, "displayName", "Form".concat(fieldName, "Field"));
    _defineProperty(Field, "defaultProps", {
      cnt: function cnt() {
        return null;
      },
      includePrefix: true,
      msg: function msg() {
        return null;
      }
    });
    return createContextExtractor(fieldName)(connect(function (state, _ref4) {
      var onionFormName = _ref4.onionFormName;
      return {
        field: state.onionForm.getIn(['fields', onionFormName, fieldName])
      };
    }, function (dispatch, _ref5) {
      var onionFormName = _ref5.onionFormName;
      return {
        actions: bindActionCreators(createFormActions(onionFormName), dispatch)
      };
    })(Field));
  };
}